import { proxy, type ref, useSnapshot } from 'valtio';

import { type CanvasAnalyticsWebClient } from './analytics-web-client';

export interface AnalyticsContext {
  client: ReturnType<typeof ref<CanvasAnalyticsWebClient>> | null;
}

export const analyticsContext = proxy<AnalyticsContext>({
  client: null,
});

export const useAnalyticsContext = () => {
  const context = useSnapshot(analyticsContext);

  return context;
};
